"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const images_1 = require("../../services/images");
const react_easy_crop_1 = __importDefault(require("react-easy-crop"));
const ButtonWeb_1 = __importDefault(require("./ButtonWeb"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const imageUtils_1 = require("../../http/imageUtils");
const react_i18next_1 = require("react-i18next");
const react_modal_1 = __importDefault(require("react-modal"));
const userHandlers_1 = require("../../handlers/userHandlers");
const AddImage = () => {
    const [image, setImage] = (0, react_1.useState)(null);
    const [crop, setCrop] = (0, react_1.useState)({ x: 0, y: 0 });
    const [croppedAreaPixels, setCroppedAreaPixels] = (0, react_1.useState)(null);
    const [trimLoading, setTrimLoading] = (0, react_1.useState)(false);
    const [imageLoading, setImageLoading] = (0, react_1.useState)(false);
    const [fileLargeError, setFileLargeError] = (0, react_1.useState)(false);
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const fileRef = (0, react_1.useRef)(null);
    const [imageKey, setImageKey] = (0, react_1.useState)(0);
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'account.set_profile.image' });
    const selectImageHandler = (event) => {
        event.preventDefault();
        setImageLoading(true);
        const file = event.target.files && event.target.files[0];
        const maxSizeInBytes = 15e6; // 15MB in bytes
        if (file && file.size <= maxSizeInBytes) {
            setFileLargeError(false);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => setImage(reader.result);
        }
        else {
            setFileLargeError(true);
            setImageLoading(false);
        }
    };
    const showCroppedImage = (0, react_1.useCallback)(async () => {
        try {
            if (typeof image === 'string' && croppedAreaPixels) {
                setTrimLoading(true);
                const croppedImage = await (0, imageUtils_1.getCroppedImg)(image, croppedAreaPixels);
                if (croppedImage !== null) {
                    (0, userHandlers_1.addUserImageHandler)(croppedImage);
                    setTimeout(() => {
                        setImageKey(prevKey => prevKey + 1);
                        setImage(null);
                        setTrimLoading(false);
                    }, 3000);
                }
                else {
                    console.error("Error cropping image");
                    setTrimLoading(false);
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    }, [image, croppedAreaPixels]);
    const onCropComplete = (0, react_1.useCallback)((_croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
        setImageLoading(false);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: userDetails?.image_path ? `${images_1.cloudFrontUrlAvatars + userDetails.image_path + `?key=${imageKey}`}` : images_1.icons.DefaultUser, alt: "User", className: "photo" }), (0, jsx_runtime_1.jsx)("input", { ref: fileRef, multiple: false, onChange: selectImageHandler, type: "file", accept: "image/png, image/jpeg, image/jpg", hidden: true }), imageLoading ?
                (0, jsx_runtime_1.jsx)("span", { className: "basic-spinner" }) :
                (0, jsx_runtime_1.jsx)("img", { src: images_1.icons.EditCircled, alt: "", onClick: () => fileRef.current.click(), className: "icon-clickable" }), fileLargeError && (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", { className: "error-message", children: t("file_too_large") }) }), image && typeof image === 'string' &&
                (0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: !!image, children: (0, jsx_runtime_1.jsxs)("div", { className: "cropper-modal-container", children: [(0, jsx_runtime_1.jsx)(react_easy_crop_1.default, { image: image, crop: crop, aspect: 1, onCropChange: setCrop, onCropComplete: onCropComplete, objectFit: "vertical-cover" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Blue", onClick: showCroppedImage, className: `button-image-crop ${trimLoading ? "button-loading-image" : ""}`, isDisabled: trimLoading, children: t("upload") }), (0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "White-BlueFont", className: "button-image-crop-cancel", onClick: () => setImage(null), isDisabled: trimLoading, children: t("cancel") })] })] }) })] }));
};
exports.default = AddImage;
